import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    grade_level: '',
    subject: '',
    category: '',
    group: '',
    student: '',
    created_after: '',
    created_before: '',
  },
  kpiStudent: null,
  kpiSubject: null,
}

export const kpiEvaluationsUI = createSlice({
  name: 'kpiEvaluationsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setCategory: (state, { payload }) => {
      state.tableFilters.category = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    setCreatedAfter: (state, { payload }) => {
      state.tableFilters.created_after = payload
    },
    setCreatedBefore: (state, { payload }) => {
      state.tableFilters.created_before = payload
    },
    setKpiStudent: (state, { payload }) => {
      state.kpiStudent = payload
    },
    setKpiSubject: (state, { payload }) => {
      state.kpiSubject = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGradeLevel,
  setSubject,
  setCategory,
  setGroup,
  setStudent,
  setCreatedAfter,
  setCreatedBefore,
  setKpiStudent,
  setKpiSubject,
  trackActiveFilters,
  clearAllFilters,
} = kpiEvaluationsUI.actions

export default kpiEvaluationsUI.reducer
